"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PPDropMenu_1 = __importDefault(require("../PPDropMenu"));
var TopBarItem_1 = __importDefault(require("./TopBarItem"));
var TopBar = function (props) {
    var _a;
    var _b = (0, react_1.useState)(), subMenu = _b[0], setSubMenu = _b[1];
    var _c = (0, react_1.useState)(0), subMenuTop = _c[0], setSubMenuTop = _c[1];
    var _d = (0, react_1.useState)(window.innerWidth), windowSize = _d[0], setWindowSize = _d[1];
    var _e = (0, react_1.useState)(0), leftSize = _e[0], setLeftSize = _e[1];
    var _f = (0, react_1.useState)(0), rightSize = _f[0], setRightSize = _f[1];
    var _g = (0, react_1.useState)(false), showScroll = _g[0], setShowScroll = _g[1];
    var _h = (0, react_1.useState)(false), showLeftShadow = _h[0], setShowLeftShadow = _h[1];
    var _j = (0, react_1.useState)(false), showRightShadow = _j[0], setShowRightShadow = _j[1];
    (0, react_1.useEffect)(function () {
        setLeftSize(windowSize - rightSize);
        setShowScroll((props.items.top.length) > Math.floor(((leftSize - 52) / 62)));
        setShowRightShadow((itemsRef.current.scrollWidth - itemsRef.current.scrollLeft) !== itemsRef.current.offsetWidth);
    }, [windowSize, leftSize, rightSize, props.items]);
    var handleLeave = function () {
        setSubMenu(undefined);
    };
    var onResize = function (event) {
        event.target.outerWidth &&
            setWindowSize(event.target.innerWidth);
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener("resize", onResize, true);
        return function () {
            window.removeEventListener("resize", onResize, true);
        };
    }, []);
    var _k = (0, react_1.useState)(0), scroll = _k[0], setScroll = _k[1];
    var itemsRef = react_1.default.createRef();
    var scrollTopBar = function (value) {
        setScroll(itemsRef.current.scrollLeft + value);
        itemsRef.current.scroll(itemsRef.current.scrollLeft + value, 0);
        setShowLeftShadow(itemsRef.current.scrollLeft + value > 0);
    };
    (0, react_1.useEffect)(function () {
        itemsRef.current.scroll(scroll, 0);
    }, [scroll]);
    return (react_1.default.createElement("div", { className: "topbar", onClick: function (event) { return event.target.className === "topbar" && props.onClick && props.onClick(); } },
        react_1.default.createElement("div", { className: "left", style: { width: leftSize } },
            props.items.hamburger &&
                react_1.default.createElement("div", { className: "hamburger" },
                    react_1.default.createElement(TopBarItem_1.default, { icon: 'ppi ppi-menu', tooltip: { label: !props.menuVisible && react_1.default.createElement("b", null, props.items.hamburgerLabel || 'Menu de opções'), position: "left" }, onClick: function () {
                            props.onClickHamburger ?
                                props.onClickHamburger()
                                :
                                    props.onChangeMenuVisible(!props.menuVisible);
                        } }),
                    props.menuVisible &&
                        react_1.default.createElement(PPDropMenu_1.default, { onLeave: handleLeave, items: (_a = props.items.hamburger) === null || _a === void 0 ? void 0 : _a.map(function (h, i) {
                                return !h.divider ?
                                    react_1.default.createElement("div", { key: i, className: "item".concat((h.selected || (subMenu !== undefined && subMenu === h.children)) ? " selected" : ""), onClick: function (event) {
                                            setSubMenuTop(event.target.offsetTop);
                                            setSubMenu(undefined);
                                            if (h.children && h.children.length > 0) {
                                                setSubMenu(h.children);
                                            }
                                            else {
                                                h.onClick();
                                                props.onChangeMenuVisible(false);
                                            }
                                        } },
                                        react_1.default.createElement("div", { className: "label" }, h.name),
                                        h.children && h.children.length > 0 &&
                                            react_1.default.createElement("i", { className: "ppi ppi-chevron-right" }))
                                    :
                                        react_1.default.createElement("hr", { key: i });
                            }), subItems: subMenu && subMenu.length > 0 &&
                                subMenu.map(function (s, i) {
                                    return !s.divider ?
                                        react_1.default.createElement("div", { key: i, className: "item sub".concat(s.selected ? " selected" : ""), onClick: function () {
                                                s.onClick &&
                                                    s.onClick();
                                                props.onChangeMenuVisible(false);
                                            } },
                                            s.icon &&
                                                react_1.default.createElement("i", { className: s.icon }),
                                            s.name)
                                        :
                                            react_1.default.createElement("hr", { key: i });
                                }), subMenuTop: subMenuTop })),
            showScroll &&
                react_1.default.createElement("div", { className: "nav", style: { visibility: scroll > 0 ? "unset" : "hidden" }, onClick: function () { scrollTopBar(-52); } },
                    react_1.default.createElement("i", { className: "ppi ppi-chevron-left" })),
            react_1.default.createElement("div", { className: "items", onScroll: function (event) {
                    event &&
                        setShowRightShadow((itemsRef.current.scrollWidth - event.target.scrollLeft) > itemsRef.current.offsetWidth);
                }, ref: itemsRef }, props.items.top.length > 0 &&
                props.items.top
                    .map(function (item, index) {
                    return (react_1.default.createElement(TopBarItem_1.default, { key: index, name: item.name, tooltip: { label: !item.selected && react_1.default.createElement("b", null, item.name) }, icon: item.icon || 'ppi ppi-cog', onClick: function () { item.onClick(); props.onChangeMenuVisible(false); }, selected: item.selected }));
                })),
            showLeftShadow && react_1.default.createElement("span", { className: 'shadow' })),
        props.right &&
            react_1.default.createElement("div", { className: "right", onClick: function () { return props.onClick && props.onClick(); }, ref: function (ref) { ref && ref.clientWidth && setRightSize(ref.clientWidth); } },
                showScroll &&
                    react_1.default.createElement("div", { className: "nav", style: { visibility: showRightShadow ? "unset" : "hidden" }, onClick: function () { scrollTopBar(52); } },
                        react_1.default.createElement("i", { className: "ppi ppi-chevron-right" })),
                props.right)));
};
exports.default = TopBar;
